import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

const POPUP_KEY = "newsletter_popup_shown";

const NewsletterPopup = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [gdpr, setGdpr] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const shown = localStorage.getItem(POPUP_KEY);
    if (shown) return;
    const timer = setTimeout(() => {
      setOpen(true);
      localStorage.setItem(POPUP_KEY, "1");
    }, 15000); // Show after 15s
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!gdpr) { toast.error("Debes aceptar la política de privacidad"); return; }
    setLoading(true);
    const { error } = await supabase.from("newsletter_subscribers").insert({
      email: email.trim().toLowerCase(),
      gdpr_consent: true,
      gdpr_consent_at: new Date().toISOString(),
    });
    setLoading(false);
    if (error) {
      if (error.code === "23505") toast.info("Ya estás suscrito");
      else toast.error("Error al suscribirte");
    } else {
      toast.success("¡Suscrito! Recibirás novedades cada semana.");
      setOpen(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <Mail className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center font-display">No te pierdas ningún chollo</DialogTitle>
          <DialogDescription className="text-center">
            Recibe 2 veces por semana los últimos patinetes publicados y ofertas que siguen disponibles.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="email"
            placeholder="tu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className="flex items-start gap-2">
            <Checkbox id="nl-gdpr" checked={gdpr} onCheckedChange={(v) => setGdpr(!!v)} className="mt-1" />
            <Label htmlFor="nl-gdpr" className="text-xs text-muted-foreground leading-relaxed">
              Acepto recibir emails de novedades. Puedo darme de baja en cualquier momento. 
              Consulta nuestra <a href="/privacidad" className="text-primary underline">Política de Privacidad</a>.
            </Label>
          </div>
          <Button className="w-full" type="submit" disabled={loading}>
            {loading ? "Suscribiendo..." : "Suscribirme gratis"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default NewsletterPopup;
